import * as o2Api from "../api";

export const getProductMappingList = async (params) => {
    try {
        const { data: result } = await o2Api.getProductMappingList(params);
        const { responseBody, responseCode, responseMessage } = result;
        if (responseCode === "200") {
            // 성공
            return responseBody;
        }
        else {
            return [];
        }
    } catch (e) {
        console.error(e.message);
        return [];
    }
};

export const putProductMapping = async (params) => {
    try {
        const {data: result} = await o2Api.putProductMapping(params);
        const { responseBody, responseCode, responseMessage } = result;
        if (responseCode === "200") {
            // 성공
            return responseBody;
        }
        else {
            return {};
        }
    }
    catch (e) {
        console.error(e.message);
        return {};
    }
}